export function getNodeFirstChild(node?: HTMLElement | null): HTMLElement | null {
  if (!node) return null;
  return node.firstElementChild as HTMLElement;
}
